module.exports = __webpack_public_path__ + "img/trion-v1-series-rtk-rover.d6f0763.png";